// extracted by mini-css-extract-plugin
module.exports = {"selected":"streamSvcPlaylist_selected__1EfjR"};